if (document.body.classList.contains("contact")) {
    const param = getAllParameters();

    if (param.i1) {
        const select = document.querySelector("select");
        select.querySelector(`option[value=${param.i1}]`).selected = true;
    }
}

/**
 * URLからすべてのパラメーターをオブジェクトとして取得する関数
 * @returns {Object} パラメーター名と値のペアを持つオブジェクト
 */
function getAllParameters() {
    var params = {};
    var queryString = window.location.search.substring(1);
    var paramArray = queryString.split("&");

    for (var i = 0; i < paramArray.length; i++) {
        var param = paramArray[i].split("=");
        var paramName = decodeURIComponent(param[0]);
        var paramValue = decodeURIComponent(param[1]);
        params[paramName] = paramValue;
    }

    return params;
}
